export default {
  generate: () => Math.random().toString(36).substr(2)
}
